export default {
  permissions:{
    view_backend : 'view backend',
    view_dashboard : 'view dashboard',
    view_agency : 'view agency',
    create_agency : 'create agency',
    edit_agency : 'edit agency',
    delete_agency : 'delete agency',
    freeze_agency : 'freeze agency',
    unfreeze_agency : 'unfreeze agency',
    view_agency_bank_details : 'view agency bank details',
    edit_agency_bank_details : 'edit agency bank details',
    view_agency_limits : 'view agency limits',
    edit_agency_limits : 'edit agency limits',
    view_agency_products : 'view agency products',
    create_agency_products : 'create agency products',
    edit_agency_products : 'edit agency products',
    delete_agency_products : 'delete agency products',
    view_agency_contacts : 'view agency contacts',
    create_agency_contacts : 'create agency contacts',
    edit_agency_contacts : 'edit agency contacts',
    delete_agency_contacts : 'delete agency contacts',
    view_agency_business : 'view agency business',
    view_agency_tasks : 'view agency tasks',
    create_agency_tasks : 'create agency tasks',
    edit_agency_tasks : 'edit agency tasks',
    delete_agency_tasks : 'delete agency tasks',
    view_agency_documents : 'view agency documents',
    create_agency_documents : 'create agency documents',
    delete_agency_documents : 'delete agency documents',
    approve_agency_documents : 'approve agency documents',
    view_business : 'view business',
    create_business : 'create business',
    edit_business : 'edit business',
    delete_business : 'delete business',
    view_business_products : 'view business products',
    edit_business_products : 'edit business products',
    create_business_products : 'create business products',
    approve_business_products : 'approve business products',
    view_business_properties : 'view business properties',
    create_business_properties : 'create business properties',
    edit_business_properties : 'edit business properties',
    delete_business_properties : 'delete business properties',
    approve_business_properties : 'approve business properties',
    view_business_contacts : 'view business contacts',
    create_business_contacts : 'create business contacts',
    edit_business_contacts : 'edit business contacts',
    delete_business_contacts : 'delete business contacts',
    view_business_feedlots : 'view business feedlots',
    create_business_feedlots : 'create business feedlots',
    delete_business_feedlots : 'delete business feedlots',
    view_business_counterparties : 'view business counterparties',
    create_business_counterparties : 'create business counterparties',
    edit_business_counterparties : 'edit business counterparties',
    delete_business_counterparties : 'delete business counterparties',
    view_business_statements : 'view business statements',
    create_business_statements : 'create business statements',
    view_business_tasks : 'view business tasks',
    create_business_tasks : 'create business tasks',
    edit_business_tasks : 'edit business tasks',
    delete_business_tasks : 'delete business tasks',
    view_business_documents : 'view business documents',
    create_business_documents : 'create business documents',
    delete_business_documents : 'delete business documents',
    approve_business_documents : 'approve business documents',
    freeze_business : 'freeze business',
    unfreeze_business : 'unfreeze business',
    view_awaiting_purchases : 'view awaiting purchases',
    view_pending_purchases : 'view pending purchases',
    view_purchase : 'view purchase',
    create_purchase : 'create purchase',
    edit_purchase : 'edit purchase',
    delete_purchase : 'delete purchase',
    refresh_bt_purchase : 'refresh bt purchase',
    edit_purchase_progress_status : 'edit purchase progress status',
    edit_purchase_approved_status : 'edit purchase approved status',
    unlock_purchase : 'unlock purchase',
    export_xero_purchase : 'export xero purchase',
    edit_xero_purchase : 'edit xero purchase',
    edit_xero_purchase_approved : 'edit xero purchase approved',
    edit_purchase_product : 'edit purchase product',
    edit_approved_purchase_product : 'edit approved purchase product',
    edit_purchase_fund : 'edit purchase fund',
    edit_purchase_terms : 'edit purchase terms',
    view_purchase_comments : 'view purchase comments',
    create_purchase_comments : 'create purchase comments',
    delete_purchase_comments : 'delete purchase comments',
    view_sale : 'view sale',
    create_sale : 'create sale',
    delete_sale : 'delete sale',
    edit_sale_progress_status : 'edit sale progress status',
    edit_sale_approved_status : 'edit sale approved status',
    unreconcile_approved_sale : 'unreconcile approved sale',
    unreconcile_progress_sale : 'unreconcile progress sale',
    change_settlement_date_progress_sale : 'change settlement date progress sale',
    change_settlement_date_approved_sale : 'change settlement date approved sale',
    export_xero_sale : 'export xero sale',
    edit_xero_sale : 'edit xero sale',
    view_rfid_lookup : 'view rfid lookup',
    change_status_rfid_lookup : 'change status rfid lookup',
    view_nlis_report : 'view nlis report',
    edit_nlis_report : 'edit nlis report',
    view_pic_search : 'view pic search',
    link_pic_search : 'link pic search',
    view_beast_enquiry : 'view beast enquiry',
    view_nlis_transferred_out : 'view nlis transferred out',
    view_overdue_transactions : 'view overdue transactions',
    view_balance_errors_report : 'view balance errors report',
    view_deleted_records : 'view deleted records',
    restore_deleted_records : 'restore deleted records',
    access_backend_users : 'access backend users',
    access_client_portal_users : 'access client portal users',
    access_role_management : 'access role management',
    access_statement_settings : 'access statement settings',
    access_classifications : 'access classifications',
    logs_viewer : 'logs viewer',
    xero_settings : 'xero settings',
    salesforce_settings : 'salesforce settings',
    search : 'search',
    view_transaction : 'view transaction',
    create_transaction : 'create transaction',
    edit_transaction : 'edit transaction',
    delete_transaction : 'delete transaction',
    view_salesforce_agency : 'view salesforce agency',
    view_xero_agency : 'view xero agency',
    enable_agency : 'enable agency',
    view_salesforce_business : 'view salesforce business',
    view_xero_business : 'view xero business',
    approve_business : 'approve business',
    pending_business : 'pending business',
    view_purchase_documents : 'view purchase documents',
    create_purchase_documents : 'create purchase documents',
    delete_purchase_documents : 'delete purchase documents',
    approve_purchase_documents : 'approve purchase documents',
    view_sale_comments : 'view sale comments',
    create_sale_comments : 'create sale comments',
    delete_sale_comments : 'delete sale comments',
    view_property_documents : 'view property documents',
    create_property_documents : 'create property documents',
    delete_property_documents : 'delete property documents',
    approve_property_documents : 'approve property documents',
    edit_purchase_asset_progress_status : 'edit purchase asset progress status',
    edit_purchase_asset_approved_status : 'edit purchase asset approved status',
    delete_purchase_asset_progress_status : 'delete purchase asset progress status',
    delete_purchase_asset_approved_status : 'delete purchase asset approved status',
    delete_purchase_asset_paid_status: 'delete purchase asset paid status',
    update_lead_type : 'update lead type',

    client_portal_manage_users: 'client portal - manage users',
    client_portal_view_management_fee: 'client portal - view management fee values',
  },
  roles: {
      admin_:'administrator',
      approver : 'approver',
      financial_approver : 'financial_approver',
      user : 'user',
      agent : 'agent',
      director : 'director',
      sys_admin : 'system_administrator',
      guest : 'guest',
  }
};
